export default __webpack_public_path__ + "static/media/tab_list.bd3cf8e8.svg";